import React from "react";
import PaymentSuccess from "../Payment/PaymentSuccess";

const PlanSuccessfull = () => {
  return (
    <React.Fragment>
      <div className="plan_success">
        <PaymentSuccess />
      </div>
    </React.Fragment>
  );
};

export default PlanSuccessfull;
